import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_array_includes, assert_type_boolean } from '@shared/asserts/utils_asserts';
import { EPerfomanceCaptureLabel } from '@shared/utils/performance/e_performance_capture_label';
import { EPerformaceReferenceDuration } from '@shared/utils/performance/e_performance_reference';
import { create_performace_capture } from '@shared/utils/utils_performance';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  value: boolean;
  key: keyof STATE__ui;
}

export const LOCAL__ui_set_boolean = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_SET_BOOLEAN,
  payload,
});

export function INIT_LCAL__ui_set_boolean(state: STATE__ui, action: PayloadAction<Payload>) {
  let { key, value } = action.payload;

  let value_old = state[key];

  assert_type_boolean(value);
  assert_array_includes(['undefined', 'boolean'], typeof value_old, { key, assert_type: ENUM__error_type.VALIDATION_INVALID_TYPE });

  if (key == 'global_need_show_first_animation' && value) {
    CONSTANTS__client.PERFORMANCE_CAPTURE_LOADING_PAGE.measure_and_log();

    //recreate key for next page loading, i.e. loading page after login
    CONSTANTS__client.PERFORMANCE_CAPTURE_LOADING_PAGE = create_performace_capture(
      EPerfomanceCaptureLabel.PAGE_LOADING,
      EPerformaceReferenceDuration.CLIENT_LOAD_PAGE,
    );
  }

  (state as any)[key] = value;
}
